 
 

const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()


  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
}



 
 

 const updateField =async  function (app,_docid, _table, _data) {
 
  

   await app.callFunction({
     name: "openapi",
     data: {
       id: _docid,
       action: 'updateData',
       table: _table,
       data: _data
     }
   })
 
 }


 

const getDay = (day) => {

  var today = new Date();



  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;



  today.setTime(targetday_milliseconds); //注意，这行是关键代码

  return formatTime2(today);
}

const getMonth = (month) => {

  var today = new Date();



  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * 30 * month;



  today.setTime(targetday_milliseconds); //注意，这行是关键代码

  return formatTime2(today).substring(0, 7);
}


const formatTime3 = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()


  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
}
const formatTime2 = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return [year, month, day].map(formatNumber).join('-')
}
const formatTime4 = date => {

  const month = date.getMonth() + 1
  const day = date.getDate()



  return month + "月" + day + '日'
}

const getLocalTime = function () {
  let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
  return date;
}



const formatTimeSN = () => {
  //  let date = new Date(+new Date() + 8 * 3600 * 1000);
  let date = new Date();
  let year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  year = year % 100;

  return [year, month, day].map(formatNumber).join('');
}
const formatTimeSN2 = (date) => {

  let year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  year = year % 100;

  return [year, month, day].map(formatNumber).join('');
}

 const  validatemobileNumber=(mobile)=> {
  // 定义手机号的正则表达式模式
  var pattern = /^1[3456789]\d{9}$/;
  
  if (pattern.test(mobile)) {
      console.log("手机号格式正确");
      return true;
  } else {
      console.log("手机号格式不正确");
      return false;
  }
}


const getTimeBag = () => {
  let _time = new Date()

  return {
    time: _time,
    time2: formatTime(_time),
    time3: formatTime2(_time),
    time4: formatTime4(_time),
    month: formatTime2(_time).substr(0, 7),
    timeStamp: _time.getTime()



  }

}

const getTimeBag2 = (_time) => {


  return {
    time: _time,
    time2: formatTime(_time),
    time3: formatTime2(_time),
    time4: formatTime4(_time),
    timeStamp: _time.getTime()
  }

}


const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * 处理服务器扫码带进来的参数
 * @param string param 扫码携带参数
 * @param string k 整体分割符 默认为：&
 * @param string p 单个分隔符 默认为：=
 * @return object
 * 
 */

/*
 * 合并数组
 */
const SplitArray = function (list, sp) {
  if (typeof list != 'object') return [];
  if (sp === undefined) sp = [];
  for (var i = 0; i < list.length; i++) {
    sp.push(list[i]);
  }
  return sp;
}


// 存储
const _setStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
}
// 查找
const _getStorage = (key) => {
  return JSON.parse(sessionStorage.getItem(key));
}

const _getForIndexStorage = (index) => {
  return sessionStorage.key(index)
}
// 删除
const _removeStorage = (key) => {
  sessionStorage.removeItem(key);
}
// 清空
const _removeAllStorage = () => {
  sessionStorage.clear();
}

const isValidmobileNumber = (mobileNumber) => {
  // 正则表达式匹配中国大陆手机号
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(mobileNumber);
}

const getNewOrderNo = async (app, shopId) => {
  const db = app.database();
  let today = getTimeBag().time3;
  let orderCount = await db.collection("my_order").where({
    "createAt.time3": today,
    shopId
  }).count().then(res => {
    return res.total;
  })



  let orderNo = formatTimeSN() * 1000 + orderCount + 1;


  return orderNo;

}


const getTempFileURL = async (app,picList) => {

  if(!picList.length)
  return [];
  try {

      let fileList=picList.map(item=>{
          return { fileID: item, maxAge:60}
      })
      const res = await app.getTempFileURL({
          fileList
      });
      return res.fileList.map(el => el.tempFileURL); // 返回所有文件的下载链接数组
  } catch (err) {
      console.error('获取临时文件URL失败:', err);
      throw err; // 抛出错误以便调用者可以处理
  }
};

const getTempFileURLSingle = async (app,fileId) => {
  if (!fileId) return '';
  try {

      const res = await app.getTempFileURL({
          fileList: [fileId]
      });

      return res.fileList[0].tempFileURL; // 返回所有文件的下载链接数组
  } catch (err) {
      console.error('获取临时文件URL失败:', err);
      throw err; // 抛出错误以便调用者可以处理
  }
};

 const uploadActiveCanvasImg = async (app,canasImgPath, type = "",shopId) => {


 

   const {fileID} = await app.uploadFile({
     cloudPath: shopId+new Date().getTime() + ".png",
     filePath: canasImgPath, // 文件路径
   });
   logCloudFileInfo(app,fileID, type,shopId);
 
   
   return fileID;


 }
const logCloudFileInfo = (app,fileid, type,shopId) => {


  const db = app.database();
  db.collection("my_fileLog").add({

    data: {
      fileid: fileid,
      date: new Date(),
      type: type,
      shopId

    }
  })
}

export  {
  formatTime,
  _removeAllStorage,
  _removeStorage,
  _getForIndexStorage,
  _getStorage,
  _setStorage,
  isValidmobileNumber,
  SplitArray,
  getNewOrderNo,
  getLocalTime,
  formatTimeSN,
  getTempFileURL,
  getTempFileURLSingle,
  formatTime2,
  formatTime3,
  formatTime4,
  getTimeBag,
  getTimeBag2,
  validatemobileNumber,
  getDay,
  formatTimeSN2,
  logCloudFileInfo,
  getMonth,
  uploadActiveCanvasImg,
  updateField

}